import {useEffect, useState} from 'react';

interface MemoryStats {
  usedMemoryMB: number;
  usagePercentage: number;
}

const INITIAL_MEMORY_STATS: MemoryStats = {
  usedMemoryMB: 0,
  usagePercentage: 0,
};

const BYTES_TO_MB = 1024 * 1024;
const POLL_INTERVAL_MS = 1000;

const getMemoryStats = (): MemoryStats => {
  const performanceMemory = (performance as any).memory;

  if (!performanceMemory) {
    return INITIAL_MEMORY_STATS;
  }

  const usedMemoryMB = Math.round(performanceMemory.usedJSHeapSize / BYTES_TO_MB);
  const usagePercentage = Math.round(
    (performanceMemory.usedJSHeapSize / performanceMemory.jsHeapSizeLimit) * 100
  );

  return {
    usedMemoryMB: usedMemoryMB,
    usagePercentage: usagePercentage,
  };
};

export const useMemoryUsage = (): MemoryStats => {
  const [memoryStats, setMemoryStats] = useState<MemoryStats>(getMemoryStats);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setMemoryStats(getMemoryStats());
    }, POLL_INTERVAL_MS);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return memoryStats;
};
